/** Error pages. */
const dictionary = {
  "en": {
    "notFound": {
      "code": "404",
      "title": "page not found",
      "subtitle": "back to home page",
      "backHome": "back to home page"
    }
  },
  "de": {
    "notFound": {
      "code": "404",
      "title": "Seite nicht gefunden",
      "subtitle": "zurück zur Startseite",
      "backHome": "zurück zur Startseite"
    }
  },
  "fi": {
    "notFound": {
      "code": "404",
      "title": "sivua ei löytynyt",
      "subtitle": "takaisin etusivulle",
      "backHome": "takaisin etusivulle"
    }
  }
};

export default dictionary;
